/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseTask } from '../models/BaseTask';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FacturationService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Build Facturation Csv
   * ### Start constructing the facturation csv
   *
   * Get the facturation csv for the last week. This is all shifts that have been accorded in the previous week.
   *
   * Args:
   * - week (int): The week number of the week to get the facturation csv for, defaults to the previous week
   * - year (int): The year of the week to get the facturation csv for, defaults to the current year
   *
   * Important to note:
   * - The function is expected to be called only by people from the office, on monday around 9:00
   *
   * Returns:
   * - The csv with all shifts that have been accorded in the previous week, that have to be facturated from collaborations: "'Te factureren: samenwerkingspartners'"
   * @param week
   * @param year
   * @returns BaseTask Successful Response
   * @throws ApiError
   */
  public postFspBuildFacturationCsv(
    week: number = 10,
    year: number = 2025
  ): CancelablePromise<BaseTask> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/fsp/facturation/facturation/csv/collaborations/week',
      query: {
        week: week,
        year: year,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Build Facturation Csv Month
   * ### Start constructing the facturation csv
   *
   * Get the facturation csv for the last month. This is all shifts that have been accorded in the previous month.
   *
   * Args:
   * - month (int): The month number of the month to get the facturation csv for, defaults to the previous month
   * - year (int): The year of the month to get the facturation csv for, defaults to the current year
   *
   * Returns:
   * - The csv with all shifts that have been accorded in the previous month, that have to be facturated from coaches: "'Uit te betalen: Studyworkers'"
   * @param month
   * @param year
   * @returns BaseTask Successful Response
   * @throws ApiError
   */
  public postFspBuildFacturationCsvMonth(
    month: number = 2,
    year: number = 2025
  ): CancelablePromise<BaseTask> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/fsp/facturation/facturation/csv/coaches/month',
      query: {
        month: month,
        year: year,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Collaboration Facturation Csv String Task
   * ### Get facturation csv task
   *
   * This endpoint gets the task status of the facturation csv task. If the task is successful, it will return the csv as a response.
   *
   * This is used for both the weekly and monthly facturation csv tasks.
   * - Weekly: "'Te factureren: samenwerkingspartners'"
   * - Monthly: "'Uit te betalen: Studyworkers'"
   *
   * Args:
   * - task_id (str): The task id of the facturation csv task
   *
   * Returns:
   * - The task status of the facturation csv task
   * @param taskId
   * @returns any Successful Response
   * @throws ApiError
   */
  public getFspGetCollaborationFacturationCsvStringTask(taskId: string): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/fsp/facturation/facturation/csv/task/{task_id}',
      path: {
        task_id: taskId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Build Facturation Csv
   * ### Start constructing the facturation csv
   *
   * Get the facturation csv for the last week. This is all shifts that have been accorded in the previous week.
   *
   * Args:
   * - week (int): The week number of the week to get the facturation csv for, defaults to the previous week
   * - year (int): The year of the week to get the facturation csv for, defaults to the current year
   *
   * Important to note:
   * - The function is expected to be called only by people from the office, on monday around 9:00
   *
   * Returns:
   * - The csv with all shifts that have been accorded in the previous week, that have to be facturated from collaborations: "'Te factureren: samenwerkingspartners'"
   * @param week
   * @param year
   * @returns BaseTask Successful Response
   * @throws ApiError
   */
  public postFspBuildFacturationCsvVLatest(
    week: number = 10,
    year: number = 2025
  ): CancelablePromise<BaseTask> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/fsp/facturation/facturation/csv/collaborations/week',
      query: {
        week: week,
        year: year,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Build Facturation Csv Month
   * ### Start constructing the facturation csv
   *
   * Get the facturation csv for the last month. This is all shifts that have been accorded in the previous month.
   *
   * Args:
   * - month (int): The month number of the month to get the facturation csv for, defaults to the previous month
   * - year (int): The year of the month to get the facturation csv for, defaults to the current year
   *
   * Returns:
   * - The csv with all shifts that have been accorded in the previous month, that have to be facturated from coaches: "'Uit te betalen: Studyworkers'"
   * @param month
   * @param year
   * @returns BaseTask Successful Response
   * @throws ApiError
   */
  public postFspBuildFacturationCsvMonthVLatest(
    month: number = 2,
    year: number = 2025
  ): CancelablePromise<BaseTask> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/fsp/facturation/facturation/csv/coaches/month',
      query: {
        month: month,
        year: year,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Collaboration Facturation Csv String Task
   * ### Get facturation csv task
   *
   * This endpoint gets the task status of the facturation csv task. If the task is successful, it will return the csv as a response.
   *
   * This is used for both the weekly and monthly facturation csv tasks.
   * - Weekly: "'Te factureren: samenwerkingspartners'"
   * - Monthly: "'Uit te betalen: Studyworkers'"
   *
   * Args:
   * - task_id (str): The task id of the facturation csv task
   *
   * Returns:
   * - The task status of the facturation csv task
   * @param taskId
   * @returns any Successful Response
   * @throws ApiError
   */
  public getFspGetCollaborationFacturationCsvStringTaskVLatest(
    taskId: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/fsp/facturation/facturation/csv/task/{task_id}',
      path: {
        task_id: taskId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
